import { useMemo } from "react";
import { motion } from "framer-motion";

// One-shot particle burst. Mount it (with a changing key) to replay.
export default function ConfettiBurst({ color = "#FF2A6D", count = 32 }) {
  const bits = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const angle = (Math.PI * 2 * i) / count + Math.random() * 0.5;
        const dist = 120 + Math.random() * 240;
        return {
          id: i,
          x: Math.cos(angle) * dist,
          y: Math.sin(angle) * dist,
          rot: Math.random() * 540,
          size: 5 + Math.random() * 9,
          delay: Math.random() * 0.08,
          dur: 1 + Math.random() * 0.5,
          square: Math.random() > 0.5,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-[130] flex items-center justify-center" aria-hidden="true" data-testid="confetti-burst">
      {bits.map((b) => (
        <motion.span
          key={b.id}
          className={b.square ? "absolute" : "absolute rounded-full"}
          style={{ width: b.size, height: b.size, background: color, boxShadow: `0 0 8px ${color}` }}
          initial={{ x: 0, y: 0, opacity: 1, rotate: 0, scale: 1 }}
          animate={{ x: b.x, y: b.y, opacity: 0, rotate: b.rot, scale: 0.3 }}
          transition={{ duration: b.dur, delay: b.delay, ease: "easeOut" }}
        />
      ))}
    </div>
  );
}
